import {Component, OnInit} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { SecurityService } from '../../security/services/security.service';
import { NotificationService } from '../../notifications/notification.service';
import { NotificationType } from '../../notifications/notification.model';
import { Password } from '../password/password.model';
import { APP_ROUTES } from 'src/app/app-routing.const';
import { notify } from '../../utils/function/notification.util';

@Component({
    selector: 'app-password-recovery-page',
    templateUrl: './password-recovery-page.component.html',
    styleUrls: ['./password-recovery-page.component.scss'],
    standalone: false
})
export class PasswordRecoveryPageComponent implements OnInit {
    token: string | null = null;
    recoveryForm: FormGroup;
    isSubmitting: boolean = false;

    // can't be empty and has to be an email
    constructor(private formBuilder: FormBuilder,
      private route: ActivatedRoute,
      private router: Router,
      private securityService: SecurityService,
      private notificationService: NotificationService) {
      this.recoveryForm = this.formBuilder.group({
        email: ['', [Validators.required, Validators.email]]
      });
    }

    ngOnInit() {
      // To verify if there is a token in the URL
      this.token = this.route.snapshot.queryParamMap.get('token');
    }

    // Called by <app-password> si there is a token
    onPasswordSetup(passwordData: Password) {
      if (!this.token) return;
      this.isSubmitting = true;

      this.securityService.changePassword(passwordData.newPassword, undefined, this.token).subscribe({
        next: () => {
          this.isSubmitting = false;
          notify(this.notificationService, NotificationType.SUCCESS, 'Your account is now active. Log in!');
          this.router.navigate([APP_ROUTES.AUTH.LOGIN]);
        },
        error: (err) => {
          this.isSubmitting = false;
          notify(this.notificationService, NotificationType.ERROR, err.error || 'The link is invalid or has expired.');
        }
      });
    }

    // Retrieving account by email
    submitRecovery() {
      if (this.recoveryForm.invalid) {
        return;
      }
      this.isSubmitting = true;

      const emailToRecover = this.recoveryForm.get('email')?.value;

          this.securityService.recover(emailToRecover).subscribe({
            next: () => {
              this.isSubmitting = false;
              this.router.navigate([APP_ROUTES.AUTH.PASSWORD_RECOVERY_CONFIRMATION]);
            },
            error: (err: any) => {
              this.isSubmitting = false;
              this.router.navigate([APP_ROUTES.AUTH.PASSWORD_RECOVERY_CONFIRMATION]); // to not let know that account exists
            }
          });
        }
    goToLogin() {
      this.router.navigate([APP_ROUTES.AUTH.LOGIN]);
    }
}
